<template>
  <font-awesome-icon
    :icon="`${theme} ${icon}`"
    v-bind="$attrs"
  ></font-awesome-icon>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'fa-regular'
    },
    icon: {
      type: String,
      required: true
    }
  }
}
</script>
